// localStorage is not always available (e.g. Safari with "Block All Cookies", some iOS WKWebViews).
// Failures are swallowed by default because most callers have a sensible fallback and would only add
// noise; pass `onError` when losing the value is worth reporting.
type OnError = (error: unknown) => void;

const getItem = (key: string, onError?: OnError): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    onError?.(error);
    return null;
  }
};

const setItem = (key: string, value: string, onError?: OnError): void => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    onError?.(error);
  }
};

const removeItem = (key: string, onError?: OnError): void => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    onError?.(error);
  }
};

export const LocalStorageService = {
  getItem,
  setItem,
  removeItem,
};
